<div class="item-quantity-title">Quantity</div>

<style lang="scss">
  .item-quantity-title {
    font-size: x-small;
    font-weight: 600;
  }
</style>
